import React, { useEffect, useState, useContext } from 'react'
import { CButton, CCol, CModal, CModalBody, CModalFooter, CRow, CFormLabel } from '@coreui/react'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'
import useAxios from 'axios-hooks'
import { SUBSCRIPTION_API, SYSTEM_METADATA_API, IPTV_CHANNEL_FILTER } from 'src/views/utils/urls'
import AssetFilter from 'src/views/container/AssetManager/AssetFilter'
import InfiniteScroll from 'react-infinite-scroll-component'
import { isArray } from 'lodash'
import { getThumbnail } from 'src/views/utils/helper'
import { GlobalContext } from 'src/views/context/GlobalState'
import CustomListCard from 'src/views/container/AssetManager/customListCard'

const IPTVchannelModal = () => {
  const { userSessionObj } = useContext(GlobalContext)
  const { setLoader, loader, iptvModalProps, setIptvModalProps } = useContext(AppContext)
  const { mappedChannelId, selectCallback } = iptvModalProps
  const [channels, setChannels] = useState([])
  const [page, setPage] = useState(1)
  const [filterPayloadObj, setFilterPayloadObj] = useState({})
  const [selectedChannelId, setSelectedChannelId] = useState(mappedChannelId)

  const [searchText, setSearchText] = useState('')
  const [categoryFilter, setCategoryFilter] = useState([])
  const [subscriptionFilter, setSubcriptionFilter] = useState([])
  const [PPVFilter, setPPVFilter] = useState([])
  const [statusFilter, setStatusFilter] = useState('')
  const [categoryMasterData, setCategoryMasterData] = useState([])
  const [subscriptionMasterData, setSubscriptionMasterData] = useState([])
  const [ppvMasterData, setPPVMasterData] = useState([])
  const [filters, setFilters] = useState([])

  const [{ data: subscriptionList, loading: subscriptionListLoading }] = useAxios({
    url: SUBSCRIPTION_API,
    method: 'get',
  })

  const [{ data: categoryList, loading: categoryListLoading }] = useAxios({
    url: SYSTEM_METADATA_API,
    method: 'get',
  })

  const [{ data: channelList, loading: channelListLoading }, channelListCall] = useAxios(
    {
      url: IPTV_CHANNEL_FILTER,
      method: 'post',
    },
    {
      manual: true,
    },
  )
  useEffect(() => {
    channelListCall({
      data: {
        filters: {},
        order_by: 'modified_date',
        reverse: true,
        page: page,
      },
    })
  }, [])

  useEffect(() => {
    if (categoryList && categoryList.success) {
      setCategoryMasterData(
        categoryList?.data?.filter((info) => info.status && info.type === 'category'),
      )
    }
  }, [categoryList])

  useEffect(() => {
    if (subscriptionList && subscriptionList.success) {
      setSubscriptionMasterData(
        subscriptionList?.data?.filter((info) => info.status && info.type === 'normal'),
      )
      setPPVMasterData(subscriptionList?.data?.filter((info) => info.status && info.type === 'ppv'))
    }
  }, [subscriptionList])

  const filterIntialValue = [
    {
      title: 'Category',
      type: 'checkbox',
      checkedState: '',
      options: categoryMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(0, setCategoryFilter, checked, value)
      },
    },
    {
      title: 'Subscription',
      type: 'checkbox',
      checkedState: '',
      options: subscriptionMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(1, setSubcriptionFilter, checked, value)
      },
    },
    {
      title: 'PPV',
      type: 'checkbox',
      checkedState: '',
      options: ppvMasterData.map((info) => {
        return { name: info.name, value: info._id }
      }),
      onSelect: (checked, value) => {
        onFilterChange(2, setPPVFilter, checked, value)
      },
    },
    {
      title: 'Status',
      type: 'radio',
      checkedState: '',
      options: [
        { name: 'Enabled', value: 'true' },
        { name: 'Disabled', value: 'false' },
      ],
      onSelect: (value) => {
        onstatusFilterChange(value)
      },
    },
  ]

  useEffect(() => {
    if (filters.filter((info) => info.checkedState !== '').length === 0) {
      setFilters([
        {
          title: 'Category',
          type: 'checkbox',
          checkedState: '',
          options: categoryMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(0, setCategoryFilter, checked, value)
          },
        },
        {
          title: 'Subscription',
          type: 'checkbox',
          checkedState: '',
          options: subscriptionMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(1, setSubcriptionFilter, checked, value)
          },
        },
        {
          title: 'PPV',
          type: 'checkbox',
          checkedState: '',
          options: ppvMasterData.map((info) => {
            return { name: info.name, value: info._id }
          }),
          onSelect: (checked, value) => {
            onFilterChange(2, setPPVFilter, checked, value)
          },
        },
        {
          title: 'Status',
          type: 'radio',
          checkedState: '',
          options: [
            { name: 'Enabled', value: 'true' },
            { name: 'Disabled', value: 'false' },
          ],
          onSelect: (value) => {
            onstatusFilterChange(value)
          },
        },
      ])
    }
  }, [categoryMasterData, subscriptionMasterData, ppvMasterData])

  useEffect(() => {
    let payload = {
      system_defined: [
        {
          key: 'category',
          name: 'Category',
          filter_type: 'AND',
          operator: 'eq',
          values: categoryFilter,
        },
        {
          key: 'active_subscription',
          name: 'Subscription',
          filter_type: 'AND',
          operator: 'eq',
          values: subscriptionFilter,
        },
        {
          key: 'active_ppv',
          name: 'PPV',
          filter_type: 'AND',
          operator: 'eq',
          values: PPVFilter,
        },
      ],
      search_text: searchText,
      // status: statusFilter,
    }
    if (typeof statusFilter !== 'string') {
      payload['status'] = statusFilter
    }
    console.log('payload', payload)
    setFilterPayloadObj(payload)
  }, [searchText, PPVFilter, subscriptionFilter, categoryFilter, statusFilter])

  useEffect(() => {
    if (channelList && channelList.success) {
      page === 1
        ? setChannels(channelList.data)
        : setChannels((channel) => [...channel, ...channelList.data])
    }
  }, [channelList])

  useEffect(() => {
    setLoader(subscriptionListLoading || categoryListLoading || channelListLoading)
  }, [subscriptionListLoading, categoryListLoading, channelListLoading])

  const handleSearch = (value) => {
    setPage(1)
    setSearchText(value)
    channelListCall({
      data: {
        filters: { ...filterPayloadObj, search_text: value },
        page: 1,
        order_by: 'modified_date',
        reverse: true,
      },
    })
  }

  const handleNextPage = () => {
    channelListCall({
      data: {
        filters: filterPayloadObj,
        page: page + 1,
        order_by: 'modified_date',
        reverse: true,
      },
    })
    setPage((page) => page + 1)
  }

  const applyFilter = () => {
    setPage(1)
    channelListCall({
      data: {
        filters: filterPayloadObj,
        page: 1,
        order_by: 'modified_date',
        reverse: true,
      },
    })
  }

  const resetFilters = () => {
    setFilters(filterIntialValue)
    setCategoryFilter([])
    setSubcriptionFilter([])
    setPPVFilter([])
    setStatusFilter('')
    setPage(1)
    channelListCall({
      data: {
        filters: { search_text: searchText },
        page: 1,
        order_by: 'modified_date',
        reverse: true,
      },
    })
  }

  const onstatusFilterChange = (value) => {
    setStatusFilter(value === '' ? '' : value === 'true' ? true : false)
    handleFilterChange(3, value)
  }

  const onFilterChange = (index, setStateFunc, checked, value) => {
    if (checked) {
      setStateFunc((prev) => {
        handleFilterChange(index, [...prev, value])
        return [...prev, value]
      })
    } else {
      setStateFunc((prev) => {
        handleFilterChange(
          index,
          [...prev].filter((type) => type !== value),
        )
        return [...prev].filter((type) => type !== value)
      })
    }
  }

  const handleFilterChange = (index, value) => {
    setFilters((prev) => {
      prev[index] = { ...prev[index], checkedState: value }
      return [...prev]
    })
  }

  const handleChannelSelect = (info) => {
    info._id === selectedChannelId ? setSelectedChannelId('') : setSelectedChannelId(info._id)
    return
  }

  const handleSelect = () => {
    const channelObj = channels.find((info) => info._id === selectedChannelId)
    if (selectedChannelId && channelObj) {
      selectCallback(channelObj)
      setIptvModalProps({})
    }
  }

  return (
    <CModal scrollable size="xl" visible={true} alignment="center" className="content-modal-full">
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CRow className="mx-5 mt-4">
        <p style={{ fontSize: '1.5625vw' }} className="font-bold">
          SELECT CHANNEL
        </p>
      </CRow>
      <CRow className=" mx-5 position-relative">
        <CCol>
          <CFormLabel style={{ fontSize: '0.9vw' }}>Select from the list of TV Channels</CFormLabel>
        </CCol>
        <CCol className="d-flex justify-content-end align-items-center ">
          <div className="">
            <AssetFilter
              filters={filters}
              onSearch={handleSearch}
              onApply={applyFilter}
              onClearAll={resetFilters}
              dropdownHeight={'300px'}
            />
          </div>
        </CCol>
      </CRow>
      <CModalBody className="mx-5">
        <CRow className="mx-">
          <div style={{ maxHeight: '30rem' }} className="table-responsive" id="scrollableDiv">
            <InfiniteScroll
              dataLength={channels.length} //This is important field to render the next data
              next={handleNextPage}
              hasMore={channelList && channelList.total > page * 20}
              style={{ overflowX: 'hidden' }}
              loader={<p>Loading...</p>}
              className="scrollbar-class position-relative"
              height={`30rem`}
              scrollableTarget="scrollableDiv"
            >
              <div
                className="d-flex justify-content-center align-items-center w-100 bg-black text-white position-absolute"
                style={{
                  fontSize: 'max(0.63vw,10px)',
                  gap: '0 2.2%',
                  padding: '2px .6vw',
                  top: '0',
                  zIndex: '10',
                }}
              >
                <div style={{ width: '9%', height: '100%' }}>Channel Name</div>
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ width: '85%' }}
                >
                  <p style={{ marginBlockEnd: '0', width: '40%' }}></p>
                  <p style={{ marginBlockEnd: '0', width: '15%' }}>Pricing</p>
                  <p style={{ marginBlockEnd: '0', width: '15%' }}>Status</p>
                  <p style={{ marginBlockEnd: '0', width: '30%' }}>Category</p>
                </div>
              </div>
              <div
                className="d-flex flex-wrap"
                style={{
                  gap: '1.2vw 0',
                  padding: '30px 8px 20px 8px',
                }}
              >
                {channels.map((info, index) => (
                  <CustomListCard
                    key={index}
                    cardImage={getThumbnail(
                      userSessionObj.session_data.cf_domain_name,
                      info?.thumbnail?.website?.s3_key,
                    )}
                    fileName={info?.name}
                    fileNameWidth={'40%'}
                    duration={''}
                    durationWidth={'0%'}
                    releasedDate={info?.is_restricted ? 'Paid' : 'Free'}
                    releasedDateWidth={'15%'}
                    contentType={info?.status ? 'Enabled' : 'Disabled'}
                    contentTypeWidth={'15%'}
                    categories={
                      isArray(info?.category)
                        ? info?.category.map((info) => info.name)
                        : [info?.category.name]
                    } // categories
                    categoryWidth={'28%'}
                    categoryMarginRight={'2%'}
                    actionButtonDisable={true}
                    isSelectable={true}
                    onSelect={() => handleChannelSelect(info)}
                    isMultipleSelectable={false}
                    isSelected={selectedChannelId === info._id}
                  />
                ))}
              </div>
            </InfiniteScroll>
          </div>
        </CRow>
      </CModalBody>
      <CModalFooter>
        <CButton
          style={{ color: 'black', border: '1px solid #bdbdbd', fontSize: '1.1rem' }}
          className="mx-4 bg-white rounded-1 btn-focus-none"
          onClick={() => setIptvModalProps({})}
        >
          Cancel
        </CButton>
        <CButton
          style={{ fontSize: '1.1rem' }}
          className=" bg-black rounded-1 btn-focus-none"
          onClick={handleSelect}
        >
          Select
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default IPTVchannelModal
